import { render, staticRenderFns } from "./BizFlow.vue?vue&type=template&id=ab0199be&scoped=true"
import script from "./BizFlow.vue?vue&type=script&lang=js"
export * from "./BizFlow.vue?vue&type=script&lang=js"
import style0 from "./BizFlow.vue?vue&type=style&index=0&id=ab0199be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab0199be",
  null
  
)

export default component.exports